module.exports = __webpack_public_path__ + "static/media/dental-care.d8f369a8.jpg";